import { render, staticRenderFns } from "./SessionsView.vue?vue&type=template&id=707b2f5d&scoped=true"
import script from "./SessionsView.vue?vue&type=script&lang=js"
export * from "./SessionsView.vue?vue&type=script&lang=js"
import style0 from "./SessionsView.vue?vue&type=style&index=0&id=707b2f5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b2f5d",
  null
  
)

export default component.exports